<template>
  <div class="col-md-6">
    <form-group-input
      ref="input"
      type="text"
      :label="label"
      :readonly="readonly"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      :data-vv-as="label"
      @input="$emit('input', $event)"
      v-validate="{ required: required, minWords: 4 }"
      />
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  name: "c-texto-medio-minimo-letras",
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  },
  created() {
    this.$validator.extend("minWords", {
      getMessage: (field, args) => {
        return `O campo requer ao menos ${args[0]} letras`;
      },
      validate: (value, args) => {
        const length = value.length;
        let result = length >= args[0];

        return result;
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Crm/TextoMedioMinimoLetras.vue